<template>
	<div>
		<v-chip
			close
			color="background darken-1"
			@input="removefilter(key)"
			v-for="(val, key) in chips"
			:key="key">
			<span class="background--text text--lighten-5 mr-1">
				{{ getChipLabel(key) }}
			</span>
			{{ val | substring(0, 24) }}
		</v-chip>
	</div>
</template>

<script>
export default {
	props: [ 'filters' ],
	data () {
		return {
			chips: {}
		}
	},
	watch: {
		filters: {
			deep: true,
			handler () {
				this.setChips()
			}
		}
	},
	methods: {
		getChipLabel (key) {
			if (key === 'search') return 'Recherche'
			if (key === 'ref_mat') return 'Ref'
			if (key === 't_aux') return 'Ayant-droit'
			if (key === 'has_rv') return 'Rv'
			if (key === 'asset_type_clean') return 'Type asset'
			if (key === 'babel_id') return 'Titre'
			if (key === 'origin') return 'Origin'
			if (key === 'behive_category') return 'Cat'
			if (key === 'has_proxy') return 'Proxy'
			if (key === 'ingest_date_after') return 'Ingest après'
			if (key === 'ingest_date_before') return 'Ingest avant'
			return ''
		},
		removefilter (filterKey) {
			this.filters[filterKey] = null
			this.$delete(this.chips, filterKey)
			this.$emit('search')
		},
		setChips () {
			for (const key in this.filters) {
				if (this.filters[key]) {
					if (key === 't_aux') {
						this.$EsMaestro.owner_search(null, this.filters[key])
							.then(owners => {
								let tAuxName = this.$commons.deepGet(owners, '0.name', this.filters[key])
								this.$set(this.chips, key, tAuxName)
							})
							.catch(err => {
								console.log(err)
							})
					} else if (key === 'babel_id') {
						this.$EsMaestro.card_read(this.filters[key], {only_label: true})
							.then(card => {
								this.$set(this.chips, key, card.label)
							})
							.catch(err => {
								this.$set(this.chips, key, `#${this.filters[key]} introuvable`)
								console.log(err)
							})
					} else if (key === 'has_rv' || key === 'has_proxy') {
						let value = this.filters[key]
						if (value === 1) value = 'Oui'
						else if (value === 2) value = 'Non'
						this.$set(this.chips, key, value)
					} else if (key === 'origin') {
						let value = this.filters[key]
						if (value === 1) value = 'Suifa'
						else if (value === 2) value = 'MAestro'
						this.$set(this.chips, key, value)
					} else {
						this.$set(this.chips, key, this.filters[key])
					}
				}
			}
			for (const key in this.chips) {
				if (!this.filters[key]) {
					this.$delete(this.chips, key)
				}
			}
		}
	},
	mounted () {
		this.setChips()
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/filesystem/title_asset_finder_filters_chips.vue